import React, { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { allPOITypes } from '@/components/TemplateBuilder/state';
import FieldAdder from './FieldAdder';

type Props = {
  allowedTemplateKeys: string[];
  mode: 'ReadOnly' | 'Edit';
  onAdd: (key: string, displayName: string) => void;
  existingKeys: string[];
};

const PoiFieldsAdder = ({ allowedTemplateKeys, mode, onAdd, existingKeys }: Props) => {
  const allTemplates = useAtomValue(allPOITypes);

  const options = useMemo(() => {
    const optionsMap = new Map<string, { key: string; name?: string | null }>();
    (allTemplates ?? [])
      .filter((template) => allowedTemplateKeys.includes((template?.key ?? '').toUpperCase()))
      .forEach((template) => {
        (template.fields ?? []).forEach((field) => {
          const key = field.key ?? '';
          if (!key) return;
          if (!optionsMap.has(key)) {
            optionsMap.set(key, { key, name: field.name ?? key });
          }
        });
      });
    return Array.from(optionsMap.values());
  }, [allTemplates, allowedTemplateKeys]);

  return (
    <FieldAdder
      options={options}
      label="Select POI field"
      mode={mode}
      existingKeys={existingKeys}
      helpText="Added fields will appear in the Nomination Fields list above."
      onAdd={(key, displayName) => onAdd(key, displayName)}
    />
  );
};

export default PoiFieldsAdder;
